// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__QcurI","footer":"ModalFilter_footer__1x5Rk"};